module.exports = __webpack_public_path__ + "static/media/ge.5e95e693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ge.png
// module id = 1857
// module chunks = 0